module.exports = __webpack_public_path__ + "img/Pr20.a9c048d9.png";